import { useNavigate } from "react-router-dom";
import { RoutedModal } from "../../../../components/common";
import { CustomerForm } from "../../../../components/secondaryComponents/customers";

const CreateCustomer = () => {
  const navigate = useNavigate();
  return (
    <RoutedModal
      isActive={true}
      width={800}
      headerTitle="Add New Customer"
      closeModal={() => navigate(-1)}
      style={{ height: "auto" }}
    >
      <CustomerForm closeModal={() => navigate(-1)} />
    </RoutedModal>
  );
};
export default CreateCustomer;
